export default "__VITE_ASSET__7KiDJtFw__"